/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { Player } from "@lottiefiles/react-lottie-player";
import blink_loader from "./blink_loader.json";

const LoadingScreen = ({ className }: { className?: string }) => {
  return (
    <div
      className={`flex items-center justify-center h-screen w-screen -bg--theme-colors-surface-neutral-level00`}
    >
      <div className={className}>
        <Player src={blink_loader} className={className} loop autoplay></Player>
      </div>
    </div>
  );
};

export default LoadingScreen;
